var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor google-drive-upload-file" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.googleDriveUploadFileChannelId"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive Channel ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "channelId", $$v)
            },
            expression: "clone.channelId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.googleDriveUploadFileDosyanNYKleneceIGoogleDriveKanalIdsi"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.googleDriveUploadFileAssetId"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Supsis Asset ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.assetId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "assetId", $$v)
            },
            expression: "clone.assetId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.googleDriveUploadFileYKlenecekDosyanNSupsisAssetIdsi"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.googleDriveUploadFileFolderIdOpsiyonel"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive Folder ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.folderId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "folderId", $$v)
            },
            expression: "clone.folderId",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.googleDriveUploadFileDosyanNYKleneceIKlasRIdsiBoBRakLRsaRootaYKlenir"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auto.googleDriveUploadFileDosyaAdOpsiyonel"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Yeni dosya adı",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.fileName,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "fileName", $$v)
            },
            expression: "clone.fileName",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.googleDriveUploadFileDosyaIInZelBirAdBoBRakLRsaOrijinalAdKullanLR"
              )
            )
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }